import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface VerificationRequest {
  code: string;
}

export default (makeCall: MakeCall) =>
  (userId: number, { code }: VerificationRequest) =>
    makeCall<undefined>('POST', `/api/v2/user/${userId}/verify-code`, {
      data: {
        code,
      },
    });
